const ALL_API = {
  // 获取省
  getProvince: {
    method: 'get',
    url: '/api/common/province'
  },
  // 获取市
  getCity: {
    method: 'get',
    url: '/api/common/city'
  },
  // 获取区
  getArea: {
    method: 'get',
    url: '/api/common/area'
  },
  // 获取当前地址信息
  getAddressInfo: {
    method: 'get',
    url: '/api/common/addressInfo'
  },
  // 获取树形结构
  getAddressTreeList: {
    method: 'get',
    url: '/api/common/getAddressTreeList'
  },
  // 获取常见问题
  getCommonQuestion: {
    method: 'get',
    url: '/api/wechat/commonQuestion'
  }
}

export default ALL_API



// WEBPACK FOOTER //
// ./src/api/public/index.js